
import { defineComponent } from "vue";

export default defineComponent({
  name: "kt-error-404",
  components: {},
});
